'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MoneyValueView: {
        displayName: 'MoneyValueView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/MoneyValue/default/MoneyValueView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MoneyValueView = _wrapComponent('MoneyValueView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(MoneyValueView, _Component);

    function MoneyValueView(props) {
        (0, _classCallCheck3.default)(this, MoneyValueView);
        return (0, _possibleConstructorReturn3.default)(this, (MoneyValueView.__proto__ || (0, _getPrototypeOf2.default)(MoneyValueView)).call(this, props));
    }

    (0, _createClass3.default)(MoneyValueView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                value = _props.value,
                icon = _props.icon,
                iconAfterValue = _props.iconAfterValue,
                prefix = _props.prefix;


            var precisionLimit = 2;
            if (icon === 'Br') {
                precisionLimit = 4;
            }
            var formattedValue = value ? parseFloat(value).toFixed(precisionLimit) : 0;
            var iconClassName = icon ? icon : 'fa fa-usd';
            var prefixString = prefix ? prefix : '';

            if (icon === 'L' || icon === 'Br' || icon === '₺' || icon === 'Dh' || icon === 'S$') {
                return _react3.default.createElement(
                    'span',
                    null,
                    prefixString,
                    _react3.default.createElement('span', { style: { marginRight: '2px' } }),
                    formattedValue,
                    ' ',
                    icon
                );
            }

            return iconAfterValue ? _react3.default.createElement(
                'span',
                null,
                prefixString,
                formattedValue,
                _react3.default.createElement('span', { className: iconClassName, style: { marginLeft: '2px' } })
            ) : _react3.default.createElement(
                'span',
                null,
                prefixString,
                _react3.default.createElement('span', { className: iconClassName, style: { marginRight: '2px' } }),
                formattedValue
            );
        }
    }]);
    return MoneyValueView;
}(_react2.Component), _class.propTypes = {
    value: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
    icon: _react2.PropTypes.string,
    iconAfterValue: _react2.PropTypes.bool,
    prefix: _react2.PropTypes.string
}, _temp));

exports.default = MoneyValueView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MoneyValue/default/MoneyValueView.jsx
// module id = 1693
// module chunks = 0